import React, { useState, useEffect } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  Typography,
  CircularProgress,
  Stack,
  TextField,
} from '@mui/material';

// NETWORK
import useDeviceRequest from '../../../../requests/DeviceRequest';

// COMPONENTS
import AllListItem from './DeviceCarrierTableRow';
import Loader from '../../../common/Loader';
import BackButton from '../../../common/BackButton';

export default function AllCarrierSelectList({
  device,
  backButtonClick,
  errorHandler,
}) {
  // Replace state with useState
  const [carriers, setCarriers] = useState([]);
  const [selectedCarrier, setSelectedCarrier] = useState(null);
  const [saveOption, setSaveOption] = useState('t');
  const [loaded, setLoaded] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const { getAllSelectableCarriers, createNewDeviceCarrierDevice } =
    useDeviceRequest();

  // Replace componentDidMount with useEffect
  useEffect(() => {
    const fetchCarriers = async () => {
      const carriers = await getAllSelectableCarriers(
        device.device_id,
        errorHandler
      );
      console.log('Got selectable carriers:', carriers);
      setCarriers(carriers);
      setLoaded(true);
    };

    fetchCarriers();
  }, [device.device_id, errorHandler]);

  // Handle form change
  const handleFormChange = (event) => {
    const { name, value } = event.target;
    if (name === 'save_option') {
      setSaveOption(value);
    }
  };

  // Handle carrier select
  const handleCarrierSelect = (carrier) => {
    setSelectedCarrier(carrier);
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSaving(true);
    await createNewDeviceCarrierDevice(
      device.device_id,
      device.device_type,
      selectedCarrier.carrier_id,
      saveOption
    );
    backButtonClick('refresh');
  };

  // Generate lander
  const generateLander = () => {
    return (
      <Stack gap={2}>
        <Box>
          <BackButton onClick={() => backButtonClick('refresh')} />
        </Box>

        <Typography variant="h4" gutterBottom>
          Add New Carrier Devices
        </Typography>
      </Stack>
    );
  };

  // Generate content
  const generateContent = () => {
    if (selectedCarrier) {
      return (
        <form onSubmit={handleSubmit} onChange={handleFormChange}>
          <Stack gap={2} maxWidth={800}>
            {generateSelect()}

            <Box>
              {!isSaving ? (
                <Button variant="contained" color="secondary" type="submit">
                  Save
                </Button>
              ) : (
                <CircularProgress />
              )}
            </Box>
          </Stack>
        </form>
      );
    }

    return generateTable();
  };

  // Generate select
  const generateSelect = () => {
    return (
      <Stack
        direction={{ xs: 'column', md: 'row' }}
        spacing={1}
        alignItems={{ md: 'center' }}
      >
        <InputLabel sx={{ minWidth: 200 }}>Device Create Method</InputLabel>
        <TextField
          select
          id="save_option"
          name="save_option"
          value={saveOption}
          onChange={handleFormChange}
          size="small"
          fullWidth
        >
          <MenuItem key={'t'} value={'t'}>
            {'This Provider Record'}
          </MenuItem>
          <MenuItem key={'d'} value={'d'}>
            {'All Dependent Records'}
          </MenuItem>
          <MenuItem key={'a'} value={'a'}>
            {'All Providers Records'}
          </MenuItem>
        </TextField>
      </Stack>
    );
  };

  // Generate table
  const generateTable = () => {
    if (carriers.length === 0)
      return <Typography>No Selectable Carriers</Typography>;

    return (
      <TableContainer sx={{ marginBottom: 4, overflowX: 'auto' }}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Carrier</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {carriers.map((carrier) => (
              <AllListItem
                key={carrier.carrier_id}
                id={carrier.carrier_id}
                carrierName={carrier.carrier_name}
                carrier={carrier}
                onClickCarrierName={() => handleCarrierSelect(carrier)}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  // Render
  return (
    <Box key="DeviceAllList">
      {loaded ? (
        <>
          {generateLander()}
          {generateContent()}
        </>
      ) : (
        <Loader />
      )}
    </Box>
  );
}
